import { render, staticRenderFns } from "./CanvasPad.vue?vue&type=template&id=f71e5be8&scoped=true"
import script from "./CanvasPad.vue?vue&type=script&lang=js"
export * from "./CanvasPad.vue?vue&type=script&lang=js"
import style0 from "./CanvasPad.vue?vue&type=style&index=0&id=f71e5be8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71e5be8",
  null
  
)

export default component.exports